import { useLocalSearchParams } from 'expo-router';
import { KpLiveGenerateView } from '@/components/kursi-play-v2/generate/KpLiveGenerateView';

type KpLanguage = 'he' | 'en' | 'ar';
type KpLevel = 'beginner' | 'intermediate' | 'advanced';
type KpTime  = '5' | '10' | '20';

export default function LearnPathGenerateRoute() {
  const { raw_content, world_name, learning_goal, language, user_id, token, level, time_per_session } =
    useLocalSearchParams<{
      raw_content:      string;
      world_name:       string;
      learning_goal:    string;
      language:         string;
      user_id:          string;
      token?:           string;
      level:            string;
      time_per_session: string;
    }>();

  return (
    <KpLiveGenerateView
      raw_content={raw_content ?? ''}
      world_name={world_name ?? ''}
      learning_goal={learning_goal ?? ''}
      language={(language as KpLanguage) ?? 'he'}
      user_id={user_id ?? ''}
      guest_session_token={token ?? ''}
      level={(level as KpLevel) ?? 'intermediate'}
      time_per_session={(time_per_session as KpTime) ?? '10'}
    />
  );
}
